<div class="d-flex justify-content-center bg-white" style="width: 100%; margin-top: -0.5rem !important;">
  <!-- Tab navigation with dynamic Bootstrap classes -->
  <ul [ngClass]="config.navClass" id="myTab" role="tablist" class="list-unstyled d-flex">
    <ng-container *ngFor="let tab of data?.tabs">

      <li *ngIf="tab.pages?.includes(data?.page)" class="nav-item" role="presentation">
        <button type="button" class="nav-link px-3 py-2 position-relative border-0 bg-transparent"
          [ngClass]="{'fw-bold text-primary': selectedTab === tab.name}" (click)="redirectToSelectedTab(tab)"
          [attr.aria-selected]="selectedTab === tab.name" style="text-decoration: none; color: inherit; outline: none;">
          {{ tab.title || tab.name }}

          <!-- Underline for active tab -->
          <span *ngIf="selectedTab === tab.name"
            class="position-absolute start-50 translate-middle-x d-block bg-primary"
            style="bottom: -2px; width: 100%; height: 3px;"></span>
        </button>
      </li>
    </ng-container>
  </ul>
</div>